import React, { useState, useRef, useEffect, useCallback } from "react";
import follow from "src/Assets/images/follow.svg";
import unfollow from "src/Assets/images/unfollow.svg";
// import dropdownarrow from "src/Assets/images/dropdownarrow.png";
import location from "src/Assets/images/userlocationtag.png";
import dot from "src/Assets/images/dot.png";
import like from "src/Assets/images/like.svg";
import unlike from "src/Assets/images/unlike.svg";
import edit from "src/Assets/images/edit.svg";
// import deleteicon from "src/Assets/images/deleteicon.png";
import privateinvite from "src/Assets/images/privateinvite.png";
// import sendanemail from "src/Assets/images/sendemail.svg";
// import report from "src/Assets/images/report.svg";
// import profileimage from "src/Assets/images/profileimage.png";
// import locationpinchildpost from "src/Assets/images/locationpinchildpost.png";
import styles from "src/Assets/css/home/post.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import { Divider } from "@material-ui/core";
import { useSelector } from "react-redux";
import SimpleDialogDemo from "../../../Modules/Reusuablecomponents/CustomizedDialogs";
import Childsay from "./ChildSay";
import ReusuableDeleteDialogmodal from "../../../Modules/Reusuablecomponents/ReusuableDeleteModal";
import ReusuableReportDialogmodal from "../../../Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import PostMessageValidation from "../../../Modules/Reusuablecomponents/PostMessageValidation";
import ReusuableSendaMailModal from "../../../Modules/Reusuablecomponents/ReusuableSendaMailModal";
// import PrivateTags from "../../../Modules/Moderator/ManageContent/PrivateTags";
import InviteFollowers from "./InviteFollowers";
import API from "../../../network";
import CircularProgress from "@material-ui/core/CircularProgress";
import NoDataFound from "src/Assets/images/data-not-found.svg";
import IconButton from "@material-ui/core/IconButton";
import { Menu, MenuItem } from "@szhsin/react-menu";
import AvatarBadge from "src/Components/AvatarBadge";
import _ from "lodash";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import MapDialog from "./LocationAddress";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import { ProfileHoverCard } from "./ProfileHoverCard";
import replyIcon from "src/Assets/images/message new icon.png";
import answerIcon from "src/Assets/images/answerIcon.png";
import PostAttachmentViewer from "../../../Utils/PostAttachmentViewer";
import Tooltip from "@mui/material/Tooltip";
import { PiDotsThreeBold } from "react-icons/pi";
import ReusuableTagActionModal from "src/Utils/ReusuableTagActionModal";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";

const FeedPost = (props) => {
  const {
    loading,
    followData,
    privateTagsData,
    childSaysData,
    fetchChildSaysData,
    postChildSayData,
    fetchFollowData,
    fetchVoteUpStatus,
    fetchPrivateTagsData,
    fetchFeedData,
    deleteMessage,
    refreshFeedData,
    feedPageNumber,
    fetchPageFeed,
    filtertype,
    fetchContributors,
    onHashTagClick,
    isActionDisabled = false,
    onActionSuccess,
  } = props;

  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [listData, setListData] = useState([]);
  const [feedListPage, setFeedListPage] = useState(feedPageNumber);
  const [isLoading, setIsLoading] = useState(false);
  const [isFeed, setFeed] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isDeletePost, setDeletePost] = useState(false);
  const [isDeletePostId, setDeletePostId] = useState();
  const [invitesShow, setInvitesShow] = React.useState(false);
  const [invite, setInvite] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [isRead, setIsRead] = useState(false);
  const [currentSayId, setCurrentSayId] = useState(null);
  const [msgId, setMsgId] = useState(null);
  const [editPostId, setEditPostId] = useState(null);
  const [openMap, setOpenMap] = useState(false);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);
  const loader = useRef(null);
  const listRef = useRef(null);
  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);

  useEffect(() => {
    setFeedListPage(feedPageNumber);
    setHasMore(true);
  }, [feedPageNumber]);

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  useEffect(() => {
    setListData(props.listData);
  }, [props.listData]);

  useEffect(() => {
    const fetchFeedData = async () => {
      setIsLoading(true);
      const newPageNumber = (feedListPage - 1) * 10;
      try {
        const response = await API.fetchFeedData(filtertype, newPageNumber);
        const { feed } = response.data;
        if (feed && Array.isArray(feed) && feed.length) {
          setListData((prevFeedList) =>
            _.unionBy([...prevFeedList, ...response.data.feed], "id"),
          );
        } else {
          setHasMore(false); // No more data available
        }
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
        console.error(e);
      }
    };

    fetchFeedData();
  }, [feedListPage]);

  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];
      if (props.data.totalfeedsizeincommunity !== props.data.breadCountLength) {
        if (target.isIntersecting) {
          // dispatch(feedactions.fetchFeedData(`?startlimit=${props.data.breadCountLength}${props.filtertype}`))
          // if(props.listdata)
          // {
          //     setFeed(oldFeed=>[...oldFeed,this.props.listdata])
          //     console.log(isFeed)
          // }
        }
      }
    },
    [props.data],
  );

  const options = {
    root: null,
    rootMargin: "20px",
    threshold: 0,
  };
  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) observer.observe(loader.current);

    return () => {
      if (loader.current) observer.unobserve(loader.current);
    };
  }, [loader, options]);

  useEffect(() => {
    if (isDeletePost) {
      // console.log(isDeletePostId)
      document.getElementById(isDeletePostId).style.display = "none";
    }
  }, [isDeletePost]);

  const onSayClick = (id, e) => {
    setIsRead(true);
    setCurrentSayId(id);
    const childsayid = `childsay${id}`;
    e.preventDefault();

    const childElement = document.getElementById(childsayid);

    if (childElement) {
      // Check if the element exists
      if (childElement.style.display === "block") {
        childElement.style.display = "none";
      } else {
        // Assuming dispatch and childSayActions are defined somewhere
        fetchChildSaysData(id);

        // Display the element if the ID matches
        childElement.style.display = "block";
      }
    } else {
      console.error(`Element with id ${childsayid} not found`);
    }
  };

  const handleScroll = useCallback(() => {
    if (!hasMore || isLoading) return; // indicates that there will be no more data
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight + 100 >= scrollHeight) {
      setIsLoading(true);
      setFeedListPage((prevPage) => prevPage + 1);
    }
  }, [hasMore, isLoading]);

  const updateList = (id, followStatus) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.followStatus = followStatus.includes("0") ? "N" : "Y";
    modifiedData.followCount = followStatus.includes("0")
      ? modifiedData.followCount - 1
      : modifiedData.followCount - 1 + 2;
    setListData(newData);
  };

  const updateFeedListPostMessage = (id, message, locationName, attachment) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? (message.match(urlRegex) || []) : [];

    const newData = [...listData].map((eachItem) => {
      if (eachItem?.id === id) {
        const { newSelectedLocation, ...cleanItem } = eachItem;
        const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
        const cleanDefaultMsg = (eachItem?.Message || "").replace(/<[^>]+>/g, "").trim();
        const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
        const isAttachmentAdded = attachment instanceof File;
        const isContentEdited = isTextModified || isAttachmentAdded;

        return {
          ...cleanItem,
          Message: message,
          msg: message,
          url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
          locName: locationName,
          msgLat: locationName ? eachItem.msgLat : "",
          msgLng: locationName ? eachItem.msgLng : "",
          docName: attachment?.name || eachItem.docName || "",
          docLocation: tempUrl || eachItem.docLocation || "",
          docTagged: attachment ? 1 : eachItem.docTagged,
          ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
        };
      }
      return { ...eachItem };
    });
    setListData(newData);
    onCloseEdit();
  };

  const likeUnlike = (id) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.UserLikeStatus = "InActive";
    modifiedData.voteUp = modifiedData.voteUp - 1 + 2;
    setListData(newData);
  };

  //to perform this follow unfollow actions
  const followunfollow = (id, followstatus) => {
    if (followstatus === "isFollow=0") {
      setShowUnfollowAlert({
        id,
        followstatus,
      });
    } else {
      followunfollowCallback(id, followstatus);
    }
  };

  const followunfollowCallback = (id, followstatus) => {
    updateList(id, followstatus);
    fetchFollowData(id, followstatus);
  };

  //to perform like option
  const onLikeUnlikeSelection = (id, cache) => {
    likeUnlike(id);
    fetchVoteUpStatus(id, cache);
  };

  const onEditSelection = (id) => {
    setEditPostId(id);
    // let editTextArea = `edittext${id}`;
    // let hideOriginalMessage = `hide${id}`;

    // if (document.getElementById(editTextArea).style.display === "block") {
    //   document.getElementById(editTextArea).style.display = "none";
    //   document.getElementById(hideOriginalMessage).style.display = "block";
    // } else {
    //   document.getElementById(editTextArea).style.display = "block";
    //   document.getElementById(hideOriginalMessage).style.display = "none";
    // }
  };

  const onCloseEdit = (id) => {
    setEditPostId(null);
  };

  // const replaceTagAndUrl = (Message, msg, tags, urls) => {
  //   if (msg && Array.isArray(urls) && urls.length) {
  //     return <div>{createMarkup(msg, urls)}</div>;
  //   } else if (msg && Array.isArray(tags) && tags.length && props?.onHashTagClick) {

  //     // Create a regular expression to match the hashtags
  //     const regex = new RegExp(`(${tags.join("|")})`, "g");

  //     const handleTagClick = (tag) => {
  //       console.log(`Tag clicked: ${tag}`);
  //       props?.onHashTagClick(tag);
  //     };

  //     // Split the message and map over it to replace hashtags with <a> tags
  //     const parts = msg.split(regex).map((part, index) => {
  //       if (part && tags.includes(part)) {
  //         return (
  //           <a
  //             key={index}
  //             href={`#${part.slice(1)}`}
  //             onClick={(e) => {
  //               e.preventDefault(); // Prevent default anchor behavior
  //               handleTagClick(part); // Call the onTagClick handler with the tag
  //             }}
  //           >
  //             {part}
  //           </a>
  //         );
  //       }
  //       return part;
  //     });

  //     return <div>{parts}</div>;
  //   } else {
  //     return Message;
  //   }
  // };

  // const createMarkup = (msg, urls) => {
  //   const urlRegex = /(\bhttps?:\/\/[^\s/$.?#].[^\s]*|\bwww\.[^\s/$.?#].[^\s]*)/g;
  //   const msgArray = msg.split(urlRegex);
  //   return msgArray.map((part, index) => {
  //     if (urls.includes(part)) {
  //       // For each URL, wrap it in an anchor tag
  //       return (
  //         <a key={index} href={part} target="_blank" rel="noopener noreferrer">
  //           related link
  //         </a>
  //       );
  //     }
  //     return part; // If it's not a URL, return the part of the string as plain text
  //   });
  // };

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  const onInviteSelection = (tenantId, id) => {
    setInvitesShow(true);
    setInvite(true);
    setTenantId(tenantId);
    setMsgId(id);
  };

  const followingPosts = listData.filter(
    (item) => item.followStatus === "Y" || item.followStatus === "inactive",
  );

  if (followingPosts.length === 0 && props?.value === 1) {
    return (
      <div className={styles.notFollowingContainer} key={`nopost`}>
        <img src={NoDataFound} alt="NoDataFound" width="200" />
        <p>Sorry! You have not followed any post</p>
      </div>
    );
  }

  const showMsg = (type) => {
    console.log("showMsg invoked feed", type);
    if (type === "ask") {
      return "No Community ASKs available at this time";
    } else if (type === "say") {
      return "No Community SAYs available at this time";
    } else if (type === "update") {
      return "No Community UPDATEs available at this time";
    } else if (type === "hashtag") {
      return "No Community Hashtags available at this time";
    } else {
      return "No Community data available at this time";
    }
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === editPostId);
    if (modifiedData) {
      // modifiedData.locName = newSelectedLoc;
      modifiedData.newSelectedLocation = newSelectedLoc; // Added a temporary key-value pair
    }
    setListData(newData);
  };

  const removeNewSelectedLocationKey = () => {
    const newData = listData.map((item) => {
      // Create a copy of the object without mutating the original
      const { newSelectedLocation, ...rest } = item; // Destructure and exclude the temporary key
      return rest; // Return the object without the temporary key
    });
    setListData(newData); // Update the state with the cleaned array
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        setListData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, docName: null, docLocation: null, docTagged: 0 }
              : item,
          ),
        );
        setIsAttacmentDeleted(response?.data?.status);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };

  return (
    <React.Fragment>
      <div
        id="feedScroll"
        className={styles.allFeedMainContainer}
        ref={listRef}
        onScroll={handleScroll}
      >
        {props.data &&
        Object.keys(props.data).length !== 0 &&
        userDetails &&
        Object.keys(userDetails).length !== 0 ? (
          listData ? (
            listData.map((result, index) =>
              props.value === 1 ? (
                result.followStatus === "Y" ||
                result.followStatus === "inactive" ? (
                  //this is for following data
                  <div
                    className={styles.post}
                    key={`followingfeed${result.id}${result.Update_Time}`}
                    id={`FeedDataDelete${result.id}${result.Update_Time}`}
                  >
                    <div className={feedstyles.avatarDetailsMainContainer}>
                      <div className={feedstyles.avatarDetailsContainer}>
                        {/* Avatar and Hover Container */}
                        <div className={feedstyles.avatarContainer}>
                          <AvatarBadge
                            src={
                              result?.mainuserdata?.uimage
                                ? `${profileImagePath}${result.mainuserdata.uimage}`
                                : process.env.REACT_APP_DUMMY_PROFILE_IMAGE // fallback: env dummy avatar
                            }
                            className={`${styles.avatar} ${feedstyles.profileimg}`}
                            variant="square"
                            alt={userDetails?.userData?.displayName}
                            isPrimaryModerator={String(result?.mainuserdata?.isPM) === "1"}
                            isModerator={
                              String(result?.mainuserdata?.isModerator) === "1" &&
                              String(result?.mainuserdata?.isPM) === "0"
                            }
                          />

                          {/* Hover Content */}
                          <ProfileHoverCard result={result} isActionDisabled={isActionDisabled} />
                        </div>

                        {/* Time and Location Section */}
                        <div style={{ marginLeft: "10px" }}>
                          <span
                            className={feedstyles.profilename}
                            style={{
                              display: "inline-flex",
                              width: "fit-content",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <p
                              className={feedstyles.profileUserName}
                              style={{ margin: 0 }}
                            >
                              {result.mainuserdata.displayName}
                            </p>

                            {result?.mainuserdata?.isImpactableMember === "yes" && (
                              <img
                                src={alreadyImpactfulMemberImg}
                                alt="Impactful Member"
                                title="Impactful Member"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  objectFit: "contain",
                                  flexShrink: 0,
                                }}
                              />
                            )}
                          </span>

                          {/* Time and Location */}
                          {result.locName || result.newSelectedLocation ? (
                            <div className={styles.locationandtime}>
                              <span className={feedstyles.profiletime}>
                                {result.Message_Time}{" "}
                                {result.edited === 1 && (
                                  <span> (edited {result.updated_time})</span>
                                )}
                              </span>
                              <img src={dot} alt="dot" />
                              <span
                                className={styles.locationDet}
                                onClick={() => {
                                  if (!isActionDisabled) {
                                    handleClickOpen(
                                      result.locName,
                                      result.msgLat,
                                      result.msgLng,
                                    );
                                  }
                                }}
                                style={{
                                  cursor: isActionDisabled ? "default" : "pointer",
                                  pointerEvents: isActionDisabled ? "none" : "auto",
                                }}
                              >
                                <img
                                  src={location}
                                  alt="location"
                                  className={styles.locationIcon}
                                />
                                {result.newSelectedLocation || result.locName}
                              </span>
                            </div>
                          ) : (
                            <div className={styles.locationandtime}>
                              <span className={feedstyles.profiletime}>
                                {result.Message_Time}{" "}
                                {result.edited === 1 && (
                                  <span> (edited {result.updated_time})</span>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={feedstyles.feeddropdown}>
                        <Menu viewScroll="close" reposition="auto" position="anchor"
                          menuButton={
                            <IconButton
                              style={{
                                padding: 0,
                                width: 30,
                                height: 30,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                outline: "none",
                              }}
                            >
                              {/* <MdKeyboardArrowDown fontSize={25} /> */}
                              <PiDotsThreeBold
                                fontSize={25}
                                color="rgba(0, 0, 0, 0.7)"
                              />
                            </IconButton>
                          }
                          transition
                          direction="bottom"
                          arrow
                          menuStyle={{
                            backgroundColor: "white",
                            borderRadius: 20,
                          }}
                          align="end"
                        >
                          {(result.message_type === "A" ||
                            result.Keyword_ID === "OpenASK" ||
                            result.message_type === "H" ||
                            result.Keyword_ID === "hashTAG" ||
                            result.message_type === "X" ||
                            result.message_type === "I" ||
                            result.message_type === "S" ||
                            result.Keyword_ID === "impupdate" ||
                            result.Keyword_ID === "OpenSAY") &&
                            (result.User_ID !== userDetails.userData.User_ID &&
                            userDetails.userData.moderatorStatus === "0" ? (
                              <>
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem>
                                  <ReusuableReportDialogmodal
                                    id={result.id}
                                    param={"AskorSay"}
                                  />
                                </MenuItem>
                                <MenuItem>
                                  <ReusuableSendaMailModal
                                    displayName={
                                      result.mainuserdata.displayName
                                    }
                                    id={result.id}
                                    notificationStatus={
                                      result.mainuserdata.notificationStatus
                                    }
                                  />
                                </MenuItem>
                              </>
                            ) : userDetails.userData.moderatorStatus === "1" &&
                              result.User_ID !==
                                userDetails.userData.User_ID ? (
                              <>
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem>
                                  <ReusuableDeleteDialogmodal
                                    type={result.Keyword_ID}
                                    id={result.id}
                                    // setDeletePost={setDeletePost}
                                    // setDeletePostId={setDeletePostId}
                                    deleteMessage={deleteMessage}
                                    fetchContributors={fetchContributors}
                                  />
                                </MenuItem>
                                <MenuItem>
                                  <ReusuableSendaMailModal
                                    displayName={
                                      result.mainuserdata.displayName
                                    }
                                    id={result.id}
                                    notificationStatus={
                                      result.mainuserdata.notificationStatus
                                    }
                                  />
                                </MenuItem>
                              </>
                            ) : (
                              <>
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem onClick={() => onEditSelection(result.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={edit} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit</span>
        </div>
      </MenuItem>
                                <MenuItem>
                                  <ReusuableDeleteDialogmodal
                                    type={result.Keyword_ID}
                                    id={result.id}
                                    // setDeletePost={setDeletePost}
                                    // setDeletePostId={setDeletePostId}
                                    deleteMessage={deleteMessage}
                                    fetchContributors={fetchContributors}
                                  />
                                </MenuItem>
                              </>
                            ))}
                        </Menu>
                      </div>
                    </div>
                    <div>
                      {editPostId === result?.id ? (
                        <PostMessageValidation
                          id={result.id}
                          Message={result.Message}
                          messageType={"feedTextArea"}
                          filtertype={props.filtertype}
                          post={result}
                          fetchFeedData={fetchFeedData}
                          refreshFeedData={refreshFeedData}
                          onCloseEdit={onCloseEdit}
                          latitude={result.msgLat}
                          longitude={result.msgLng}
                          locationAddress={result.locName}
                          updateNewSelectedLocation={updateNewSelectedLocation}
                          removeNewSelectedLocationKey={
                            removeNewSelectedLocationKey
                          }
                          onDeleteAttachment={handleDeleteAttachementDoc}
                          docName={result?.docName}
                          isAttacmentDeleted={isAttacmentDeleted}
                          setIsAttacmentDeleted={setIsAttacmentDeleted}
                          feedType={"allFeed"}
                          updateFeedListPostMessage={updateFeedListPostMessage}
                        />
                      ) : (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "baseline", // aligns with text bottom
                            flexWrap: "wrap",
                            gap: "5px", // small gap between text and file name
                          }}
                        >
                          <p
                            className={feedstyles.messagehidden}
                            // dangerouslySetInnerHTML={{ __html: result.Message }}
                            id={`hide${result.id}`}
                            style={{ display: "inline", margin: 0 }}
                          >
                            <TextWithUrlsAndHashTags
                              Message={result.Message}
                              text={result.msg}
                              hashtags={result.tag}
                              urls={result.url}
                              onHashtagClick={onHashTagClick}
                            />
                          </p>
                          <PostAttachmentViewer
                            docLocation={result.docLocation}
                            docTagged={result.docTagged}
                            docName={result.docName}
                            messageID={result.id}
                            className={feedstyles.myFileNameSpacingAllFeed}
                            activeTooltip={activeTooltip}
                            setActiveTooltip={setActiveTooltip}
                            onDeleteAttachment={handleDeleteAttachementDoc}
                          />
                        </div>
                      )}
                    </div>
                    <div className={styles.followerandcount}>
                      <div>
                        {result.message_type === "A" ||
                        result.Keyword_ID === "OpenASK" ||
                        result.message_type === "H" ||
                        result.Keyword_ID === "hashTAG" ||
                        result.Keyword_ID === "TrendingASK" ? (
                          <div>
                            <SimpleDialogDemo
                              followCount={result.followCount}
                              followData={result.follweduserprofile}
                              id={result.id}
                              isActionDisabled={isActionDisabled}
                              onActionSuccess={props?.onActionSuccess || onActionSuccess}
                            />

                            {/* <a className={styles.followcount} onClick={()=>onFollowersSelection()}>{result.followCount} followers</a> */}
                          </div>
                        ) : result.voteUp ? (
                          <div>
                            <SimpleDialogDemo
                              voteUp={result.voteUp}
                              id={result.id}
                              likesData={result.likeduserprofile}
                              isActionDisabled={isActionDisabled}
                              onActionSuccess={props?.onActionSuccess || onActionSuccess}
                            />
                          </div>
                        ) : (
                          <div>
                            <span className={styles.followcount}>
                              {result.voteUp === 1
                                ? `${result.voteUp} like`
                                : `${result.voteUp} likes`}
                            </span>
                          </div>
                        )}
                      </div>
                      <div>
                        {result.message_type === "A" ||
                        result.Keyword_ID === "OpenASK" ? (
                          <Tooltip title="ASK" arrow>
                            <div className={styles.askcount}>
                              {isRead ||
                              result.childcotentreadcount === 0 ? null : (
                                <p style={{ color: "#ffffff" }}>
                                  {result.childcotentreadcount}
                                </p>
                              )}
                            </div>
                          </Tooltip>
                        ) : result.message_type === "S" ||
                          result.Keyword_ID === "OpenSAY" ? (
                          <Tooltip title="SAY" arrow>
                            <div className={styles.saycount}></div>
                          </Tooltip>
                        ) : result.message_type === "I" ||
                          result.Keyword_ID === "impupdate" ? (
                          <Tooltip title="UPDATE" arrow>
                            <div className={styles.updatecount}></div>
                          </Tooltip>
                        ) : result.message_type === "H" ||
                          result.Keyword_ID === "hashTAG" ||
                          result.message_type === "X" ? (
                          <Tooltip title="TAG" arrow>
                            <div
                              className={
                                result.isNewMessage === 1 &&
                                result.sayCount === 0
                                  ? styles.tagcounter
                                  : styles.nullTagCount
                              }
                            >
                              {result.isNewMessage === 1 &&
                              result.sayCount === 0 ? (
                                <p style={{ color: "#ffffff" }}>new</p>
                              ) : result.childcotentreadcount !== 0 &&
                                isRead === false ? (
                                <p style={{ color: "#ffffff" }}>
                                  {result.childcotentreadcount}
                                </p>
                              ) : null}
                              {/* <p>{result.childcotentreadcount}</p> */}
                            </div>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <Divider variant="fullWidth" />
                    {result.message_type === "A" ||
                    result.message_type === "H" ||
                    result.message_type === "X" ||
                    result.Keyword_ID === "OpenASK" ||
                    result.Keyword_ID === "hashTAG" ? (
                      <div className={styles.saysandfollow}>
                        <div className={styles.noOfsays}>
                          <a onClick={(e) => onSayClick(result.id, e)}>
                            <img
                              src={
                                result.Keyword_ID === "OpenASK"
                                  ? answerIcon
                                  : replyIcon
                              }
                              className={
                                result.Keyword_ID === "OpenASK"
                                  ? styles.answerIcon
                                  : styles.replyIcon
                              }
                              alt="number of says"
                            />
                            <span>
                              {result.Keyword_ID === "OpenASK"
                                ? result.sayCount === 0
                                  ? "Answer"
                                  : `${result.sayCount} ${
                                      result.sayCount === 1
                                        ? "Answer"
                                        : "Answers"
                                    }`
                                : result.sayCount === 0
                                  ? "Reply"
                                  : `${result.sayCount} ${
                                      result.sayCount === 1
                                        ? "Reply"
                                        : "Replies"
                                    }`}
                            </span>
                          </a>
                        </div>
                        {result.followStatus === "inactive" ? (
                          <>
                            <div
                              className={`${feedstyles.noOffollows}`}
                              id={`1${result.id}`}
                            >
                              <a
                                className={styles.followtext}
                                onClick={() =>
                                  followunfollow(result.id, "isFollow=1")
                                }
                              >
                                <img src={follow} alt="follow" />
                                <span>Follow</span>
                              </a>
                            </div>
                            <div
                              className={`${styles.noOffollows} ${feedstyles.unfollowdisplay} `}
                              id={`0${result.id}`}
                            >
                              <a
                                className={styles.followtext}
                                onClick={() =>
                                  followunfollow(result.id, "isFollow=0")
                                }
                              >
                                <img src={unfollow} alt="unfollow" />
                                <span>Unfollow</span>
                              </a>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className={`${styles.noOffollows} `}
                              id={`0${result.id}`}
                            >
                              <a
                                className={styles.followtext}
                                onClick={() =>
                                  followunfollow(
                                    result.id,
                                    "isFollow=0",
                                    result?.hashTagType,
                                  )
                                }
                              >
                                <img src={unfollow} alt="unfollow" />
                                <span>Unfollow</span>
                              </a>
                            </div>
                            <div
                              className={`${feedstyles.noOffollows} ${feedstyles.followdisplay}`}
                              id={`1${result.id}`}
                            >
                              <a
                                className={styles.followtext}
                                onClick={() =>
                                  followunfollow(
                                    result.id,
                                    "isFollow=1",
                                    result?.hashTagType,
                                  )
                                }
                              >
                                <img src={follow} alt="follow" />
                                <span>Follow</span>
                              </a>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className={styles.likeunlike}>
                        {result.UserLikeStatus === "Active" ? (
                          <>
                            <a
                              onClick={() =>
                                onLikeUnlikeSelection(result.id, "cacheUpdate")
                              }
                              id={`like${result.id}`}
                            >
                              <img src={like} alt="like" />
                              Like
                            </a>
                          </>
                        ) : (
                          <a>
                            <img src={unlike} alt="unlike" />
                            Like
                          </a>
                        )}
                      </div>
                    )}
                    {/* .......................childsaydata ......................*/}

                    <div
                      className={styles.childsayselection}
                      id={`childsay${result.id}`}
                    >
                      <PostMessageValidation
                        id={result.id}
                        type={"childSay"}
                        userImageSrc={`${profileImagePath}${userDetails?.userData?.uimage}`}
                        postChildSayData={postChildSayData}
                        fetchChildSaysData={fetchChildSaysData}
                        refreshFeedData={refreshFeedData}
                        fetchContributors={fetchContributors}
                      />

                      {/* <div className={styles.comment}>
                                                <Avatar src={profileimage} variant="square" />

                                                <input className={styles.commentinput} placeholder="Say something..." type="text" />
                                                <a><img src={locationpinchildpost} /></a>
                                            </div>
                                            <div>
                                                <button className={styles.childpost}>POST</button>
                                            </div> */}
                      <Childsay
                        id={result.id}
                        key={result.id}
                        loading={loading}
                        childSaysData={childSaysData}
                        fetchVoteUpStatus={fetchVoteUpStatus}
                        fetchFeedData={fetchFeedData}
                        deleteMessage={deleteMessage}
                        refreshFeedData={refreshFeedData}
                        fetchContributors={fetchContributors}
                        isActionDisabled={isActionDisabled}
                        onActionSuccess={props?.onActionSuccess}
                        onHashTagClick={onHashTagClick}
                      />
                    </div>
                  </div>
                ) : null
              ) : (
                //this is for all data
                <React.Fragment key={`allfeed${result.id}`}>
                  <div
                    className={styles.post}
                    key={`allfeed${result.id}`}
                    id={`FeedDataDelete${result.id}`}
                  >
                    <div className={feedstyles.avatarDetailsMainContainer}>
                      <div className={feedstyles.avatarDetailsContainer}>
                        {/* Avatar and Hover Container */}
                        <div className={feedstyles.avatarContainer}>
                          <AvatarBadge
                            src={
                              result?.mainuserdata?.uimage
                                ? `${profileImagePath}${result.mainuserdata.uimage}`
                                : process.env.REACT_APP_DUMMY_PROFILE_IMAGE // fallback: env dummy avatar
                            }
                            className={`${styles.avatar} ${feedstyles.profileimg}`}
                            variant="square"
                            alt={userDetails?.userData?.displayName}
                            isPrimaryModerator={String(result?.mainuserdata?.isPM) === "1"}
                            isModerator={
                              String(result?.mainuserdata?.isModerator) === "1" &&
                              String(result?.mainuserdata?.isPM) === "0"
                            }
                          />

                          {/* Hover Content */}
                          <ProfileHoverCard result={result} isActionDisabled={isActionDisabled} />
                        </div>

                        {/* Time and Location Section */}
                        <div style={{ marginLeft: "10px" }}>
                          <span
                            className={feedstyles.profilename}
                            style={{
                              display: "inline-flex",
                              width: "fit-content",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <p
                              className={feedstyles.profileUserName}
                              style={{ margin: 0 }}
                            >
                              {result.mainuserdata.displayName}
                            </p>

                            {result?.mainuserdata?.isImpactableMember === "yes" && (
                              <img
                                src={alreadyImpactfulMemberImg}
                                alt="Impactful Member"
                                title="Impactful Member"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  objectFit: "contain",
                                  flexShrink: 0,
                                }}
                              />
                            )}
                          </span>

                          {/* Time and Location */}
                          {result.locName || result.newSelectedLocation ? (
                            <div className={styles.locationandtime}>
                              <span className={feedstyles.profiletime}>
                                {result.Message_Time}
                                {result.edited === 1 && (
                                  <span> (edited {result.updated_time})</span>
                                )}
                              </span>
                              <img src={dot} alt="dot" />
                              <span
                                className={styles.locationDet}
                                onClick={() => {
                                  if (!isActionDisabled) {
                                    handleClickOpen(
                                      result.locName,
                                      result.msgLat,
                                      result.msgLng,
                                    );
                                  }
                                }}
                                style={{
                                  cursor: isActionDisabled ? "default" : "pointer",
                                  pointerEvents: isActionDisabled ? "none" : "auto",
                                }}
                              >
                                <img
                                  src={location}
                                  alt="location"
                                  className={styles.locationIcon}
                                />
                                {result.newSelectedLocation || result.locName}
                              </span>
                            </div>
                          ) : (
                            <div className={styles.locationandtime}>
                              <span className={feedstyles.profiletime}>
                                {result.Message_Time}{" "}
                                {result.edited === 1 && (
                                  <span> (edited {result.updated_time})</span>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className={feedstyles.feeddropdown}>
                        <Menu viewScroll="close" reposition="auto" position="anchor"
                          menuButton={
                            <IconButton
                              style={{
                                padding: 0,
                                width: 30,
                                height: 30,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                outline: "none",
                              }}
                            >
                              {/* <MdKeyboardArrowDown fontSize={25} /> */}
                              <PiDotsThreeBold
                                fontSize={25}
                                color="rgba(0, 0, 0, 0.7)"
                              />
                            </IconButton>
                          }
                          transition
                          direction="bottom"
                          arrow
                          menuStyle={{
                            backgroundColor: "white",
                            borderRadius: 20,
                          }}
                          align="end"
                        >
                          {(result.message_type === "A" ||
                            result.Keyword_ID === "OpenASK" ||
                            result.message_type === "H" ||
                            result.Keyword_ID === "hashTAG" ||
                            result.message_type === "X" ||
                            result.message_type === "I" ||
                            result.message_type === "S" ||
                            result.Keyword_ID === "impupdate" ||
                            result.Keyword_ID === "OpenSAY") &&
                            (result.User_ID !== userDetails.userData.User_ID &&
                            userDetails.userData.moderatorStatus === "0" ? (
                              <>
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem>
                                  <ReusuableReportDialogmodal
                                    id={result.id}
                                    param={"AskorSay"}
                                  />
                                </MenuItem>
                                <MenuItem>
                                  <ReusuableSendaMailModal
                                    displayName={
                                      result.mainuserdata.displayName
                                    }
                                    id={result.id}
                                    notificationStatus={
                                      result.mainuserdata.notificationStatus
                                    }
                                  />
                                </MenuItem>
                              </>
                            ) : userDetails.userData.moderatorStatus === "1" &&
                              result.User_ID !==
                                userDetails.userData.User_ID ? (
                              <>
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem>
                                  <ReusuableDeleteDialogmodal
                                    type={result.Keyword_ID}
                                    id={result.id}
                                    // setDeletePost={setDeletePost}
                                    // setDeletePostId={setDeletePostId}
                                    deleteMessage={deleteMessage}
                                    fetchContributors={fetchContributors}
                                  />
                                </MenuItem>
                                <MenuItem>
                                  <ReusuableSendaMailModal
                                    displayName={
                                      result.mainuserdata.displayName
                                    }
                                    id={result.id}
                                    notificationStatus={
                                      result.mainuserdata.notificationStatus
                                    }
                                  />
                                </MenuItem>
                              </>
                            ) : (
                              <>
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="download"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                {(result.message_type === "H" ||
                                  result.Keyword_ID === "hashTAG" ||
                                  result.message_type === "X") && (
                                  <MenuItem>
                                    <ReusuableTagActionModal
                                      type="rating"
                                      tagId={result?.id}
                                      tagName={result?.Message}
                                      tagData={result}
                                    />
                                  </MenuItem>
                                )}
                                <MenuItem onClick={() => onEditSelection(result.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={edit} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit</span>
        </div>
      </MenuItem>
                                <MenuItem>
                                  <ReusuableDeleteDialogmodal
                                    type={result.Keyword_ID}
                                    id={result.id}
                                    // setDeletePost={setDeletePost}
                                    // setDeletePostId={setDeletePostId}
                                    deleteMessage={deleteMessage}
                                    fetchContributors={fetchContributors}
                                  />
                                </MenuItem>
                              </>
                            ))}
                        </Menu>
                      </div>
                    </div>
                    <div>
                      {editPostId === result?.id ? (
                        <PostMessageValidation
                          id={result.id}
                          Message={result.Message}
                          messageType={"feedTextArea"}
                          filtertype={props.filtertype}
                          post={result}
                          fetchFeedData={fetchFeedData}
                          refreshFeedData={refreshFeedData}
                          onCloseEdit={onCloseEdit}
                          latitude={result.msgLat}
                          longitude={result.msgLng}
                          locationAddress={result.locName}
                          updateNewSelectedLocation={updateNewSelectedLocation}
                          removeNewSelectedLocationKey={
                            removeNewSelectedLocationKey
                          }
                          onDeleteAttachment={handleDeleteAttachementDoc}
                          docName={result?.docName}
                          isAttacmentDeleted={isAttacmentDeleted}
                          setIsAttacmentDeleted={setIsAttacmentDeleted}
                          feedType={"allFeed"}
                          updateFeedListPostMessage={updateFeedListPostMessage}
                        />
                      ) : (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "baseline", // aligns with text bottom
                            flexWrap: "wrap",
                            gap: "5px", // small gap between text and file name
                          }}
                        >
                          <p
                            className={feedstyles.messagehidden}
                            // dangerouslySetInnerHTML={{ __html: result.Message }}
                            id={`hide${result.id}`}
                            style={{ display: "inline", margin: 0 }}
                          >
                            <TextWithUrlsAndHashTags
                              Message={result.Message}
                              text={result.msg}
                              hashtags={result.tag}
                              urls={result.url}
                              onHashtagClick={onHashTagClick}
                            />
                          </p>
                          <PostAttachmentViewer
                            docLocation={result.docLocation}
                            docTagged={result.docTagged}
                            docName={result.docName}
                            messageID={result.id}
                            className={feedstyles.myFileNameSpacingAllFeed}
                            activeTooltip={activeTooltip}
                            setActiveTooltip={setActiveTooltip}
                            onDeleteAttachment={handleDeleteAttachementDoc}
                          />
                        </div>
                      )}
                    </div>
                    <div className={styles.followerandcount}>
                      <div>
                        {result?.message_type === "A" ||
                        result?.Keyword_ID === "OpenASK" ||
                        result?.message_type === "H" ||
                        result?.Keyword_ID === "hashTAG" ||
                        result?.Keyword_ID === "TrendingASK" ||
                        result?.message_type === "X" ? (
                          <div>
                            <SimpleDialogDemo
                              followCount={result?.followCount}
                              followData={result?.follweduserprofile}
                              id={result.id}
                              status={followData}
                              hashTagType={result?.hashTagType}
                              isActionDisabled={isActionDisabled}
                              onActionSuccess={props?.onActionSuccess || onActionSuccess}
                            />
                          </div>
                        ) : (
                          <div>
                            <SimpleDialogDemo
                              voteUp={result?.voteUp}
                              likesData={result?.likeduserprofile}
                              id={result.id}
                              isActionDisabled={isActionDisabled}
                              onActionSuccess={props?.onActionSuccess || onActionSuccess}
                            />
                          </div>
                        )}
                      </div>
                      <div>
                        {result.message_type === "A" ||
                        result.Keyword_ID === "OpenASK" ? (
                          <Tooltip title="ASK" arrow>
                            <div className={styles.askcount}>
                              {isRead ||
                              result.childcotentreadcount === 0 ? null : (
                                <p style={{ color: "#ffffff" }}>
                                  {result.childcotentreadcount}
                                </p>
                              )}
                            </div>
                          </Tooltip>
                        ) : result.message_type === "S" ||
                          result.Keyword_ID === "OpenSAY" ? (
                          <Tooltip title="SAY" arrow>
                            <div className={styles.saycount}></div>
                          </Tooltip>
                        ) : result.message_type === "I" ||
                          result.Keyword_ID === "impupdate" ? (
                          <Tooltip title="UPDATE" arrow>
                            <div className={styles.updatecount}></div>
                          </Tooltip>
                        ) : result.message_type === "H" ||
                          result.Keyword_ID === "hashTAG" ||
                          result.message_type === "X" ? (
                          <Tooltip title="TAG" arrow>
                            <div
                              className={
                                result.isNewMessage === 1 &&
                                result.sayCount === 0
                                  ? styles.tagcounter
                                  : styles.nullTagCount
                              }
                            >
                              {result.isNewMessage === 1 &&
                              result.sayCount === 0 ? (
                                <p style={{ color: "#ffffff" }}>new</p>
                              ) : result.childcotentreadcount !== 0 &&
                                isRead === false ? (
                                <p style={{ color: "#ffffff" }}>
                                  {result.childcotentreadcount}
                                </p>
                              ) : null}
                              {/* <p>{result.childcotentreadcount}</p> */}
                            </div>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <Divider variant="fullWidth" />
                    {result.message_type === "A" ||
                    result.message_type === "H" ||
                    result.message_type === "X" ||
                    result.Keyword_ID === "OpenASK" ||
                    result.Keyword_ID === "hashTAG" ? (
                      <div className={styles.saysandfollow}>
                        <div className={styles.noOfsays}>
                          <a onClick={(e) => onSayClick(result.id, e)}>
                            <img
                              src={
                                result.Keyword_ID === "OpenASK"
                                  ? answerIcon
                                  : replyIcon
                              }
                              className={
                                result.Keyword_ID === "OpenASK"
                                  ? styles.answerIcon
                                  : styles.replyIcon
                              }
                              alt="number of says"
                            />
                            <span>
                              {result.Keyword_ID === "OpenASK"
                                ? result.sayCount === 0
                                  ? "Answer"
                                  : `${result.sayCount} ${
                                      result.sayCount === 1
                                        ? "Answer"
                                        : "Answers"
                                    }`
                                : result.sayCount === 0
                                  ? "Reply"
                                  : `${result.sayCount} ${
                                      result.sayCount === 1
                                        ? "Reply"
                                        : "Replies"
                                    }`}
                            </span>
                          </a>
                        </div>
                        {result.followStatus === "Active" ||
                        result.followStatus === "Y" ? (
                          <div
                            className={`${feedstyles.noOffollows}`}
                            id={`1${result.id}`}
                          >
                            <a
                              className={styles.followtext}
                              onClick={() =>
                                followunfollow(result.id, "isFollow=0")
                              }
                            >
                              <img src={unfollow} alt="unfollow" />
                              <span>Unfollow</span>
                            </a>
                          </div>
                        ) : (
                          <div
                            id={`0${result.id}`}
                            className={styles.noOffollows}
                          >
                            <a
                              className={styles.followtext}
                              onClick={() =>
                                followunfollow(result.id, "isFollow=1")
                              }
                            >
                              <img src={follow} alt="follow" />
                              <span>Follow</span>
                            </a>
                          </div>
                        )}
                        {result.hashTagType === "private" &&
                        (userDetails.userData.moderatorStatus === "1" ||
                          userDetails.userData.isAdmin === "1") ? (
                          <div className={feedstyles.priavteinvite}>
                            <img src={privateinvite} alt="Private Invite" />
                            <span
                              onClick={() =>
                                onInviteSelection(
                                  result.TenantID || result.tenantID,
                                  result.id,
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              Invite
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div className={styles.likeunlike}>
                        {result.UserLikeStatus === "Active" ? (
                          <>
                            <a
                              onClick={() =>
                                onLikeUnlikeSelection(result.id, "cacheUpdate")
                              }
                              id={`like${result.id}`}
                            >
                              <img src={like} alt="like" />
                              Like
                            </a>
                          </>
                        ) : (
                          <a>
                            <img src={unlike} alt="unlike" />
                            Like
                          </a>
                        )}
                      </div>
                    )}
                    {/* .......................childsaydata ......................*/}

                    <div
                      className={styles.childsayselection}
                      id={`childsay${result.id}`}
                    >
                      {currentSayId === result.id && (
                        <PostMessageValidation
                          id={result.id}
                          type={"childSay"}
                          userImageSrc={`${profileImagePath}${userDetails?.userData?.uimage}`}
                          postChildSayData={postChildSayData}
                          fetchChildSaysData={fetchChildSaysData}
                          refreshFeedData={refreshFeedData}
                          fetchContributors={fetchContributors}
                          keywordName={result.Keyword_ID}
                        />
                      )}

                      {/* <div className={styles.comment}>
                                            <Avatar src={profileimage} variant="square" />

                                            <input className={styles.commentinput} placeholder="Say something..." type="text" />
                                            <a><img src={locationpinchildpost} /></a>
                                        </div>
                                        <div>
                                            <button className={styles.childpost}>POST</button>
                                        </div> */}
                      {currentSayId === result.id && (
                        <Childsay
                          id={result.id}
                          key={result.id}
                          loading={loading}
                          childSaysData={childSaysData}
                          fetchVoteUpStatus={fetchVoteUpStatus}
                          fetchFeedData={fetchFeedData}
                          deleteMessage={deleteMessage}
                          refreshFeedData={refreshFeedData}
                          fetchContributors={fetchContributors}
                          isActionDisabled={isActionDisabled}
                          onActionSuccess={props?.onActionSuccess}
                          onHashTagClick={onHashTagClick}
                        />
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ),
            )
          ) : (
            <p className={feedstyles.nodata}>{showMsg(filtertype)}</p>
          )
        ) : (
          ""
        )}
        {invitesShow && (
          <InviteFollowers
            show={invitesShow}
            onHide={() => setInvitesShow(false)}
            invite={invite}
            tenantid={tenantId}
            msgid={msgId}
            privateTagsData={privateTagsData}
            fetchPrivateTagsData={fetchPrivateTagsData}
          />
        )}
        <div className={styles.loaderContainer}>
          {isLoading && <CircularProgress size={25} />}
        </div>
        <MapDialog
          open={openMap}
          onClose={handleCloseMap}
          clickedLocation={clickedLocation}
          zoomLevel={12}
        />
      </div>
      <div ref={loader} />
      {/* <PrivateTags /> */}
      {showUnfollowAlert && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)}
          type={"warning"}
          title={"Are you sure you want to Unfollow?"}
          acceptLabel={"Yes"}
          onAccept={() => {
            followunfollowCallback(
              showUnfollowAlert?.id,
              showUnfollowAlert?.followstatus,
            );
            setShowUnfollowAlert(null);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default FeedPost;
